/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardBannerSegment {
    getFixupPrototypeFunction() { return DashboardBannerSegment.fixupPrototype; }

    static newInstance(model: Partial<DashboardBannerSegment>): DashboardBannerSegment {
        let obj = Object.assign(new DashboardBannerSegment(), model);
        DashboardBannerSegment.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardBannerSegment>): DashboardBannerSegment {
        if (!model) return null;
        return DashboardBannerSegment.newInstance(<DashboardBannerSegment> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardBannerSegment) {
        if (!obj) return;

        models.DashboardBannerSegment.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardBannerSegment): boolean {
        Object.setPrototypeOf(obj, DashboardBannerSegment.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.widthRatio === undefined) {
            this.widthRatio = 0;
        }
        if (this.branding) {
            models.BrandingConfiguration.fixupPrototype(this.branding);
        }
    }

    widthRatio: number;

    branding: models.BrandingConfiguration;

}
